"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var routes_1 = require("@dynamynd/routes");

var formik_1 = require("formik");

var react_1 = __importStar(require("react"));

var styled_1 = require("../../styled");

var FieldLabels_enum_1 = require("./FieldLabels.enum");

var FieldNames_enum_1 = require("./FieldNames.enum");

var FormContainer_1 = __importDefault(require("./FormContainer"));

var Password_1 = require("./Password");

var styled_2 = require("./styled");

var userProfileEditFormValidationSchema_1 = require("./userProfileEditFormValidationSchema");

var UserProfileEditForm =
/** @class */
function (_super) {
  __extends(UserProfileEditForm, _super);

  function UserProfileEditForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      renderPassword: false
    };

    _this.togglePasswordVisibility = function () {
      _this.setState(function (prevState) {
        return {
          renderPassword: !prevState.renderPassword
        };
      });
    };

    _this.navigate = function () {
      _this.props.navigateTo(routes_1.RoutesKeysEnum.home);
    };

    _this.renderForm = function (props // todo fix FormInput types
    ) {
      var renderPassword = _this.state.renderPassword;
      var _a = _this.props,
          avatars = _a.avatars,
          initialValues = _a.initialValues,
          updating = _a.updating;
      var isSubmitting = props.isSubmitting; // set submitting status of the form

      if (isSubmitting && !updating) {
        props.setSubmitting(false);
      }

      return react_1.default.createElement(FormContainer_1.default, null, react_1.default.createElement(styled_1.FormSection, null, react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(styled_1.SectionLabel, null, FieldLabels_enum_1.FieldLabels.avatar)), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.ImagePickerContainer, null, react_1.default.createElement(components_lib_1.ImagePickerWithForm, __assign({
        collection: avatars,
        initialSelectedId: initialValues.avatar,
        name: FieldNames_enum_1.FieldNames.avatar
      }, props))))), react_1.default.createElement(styled_1.FormSection, null, react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(styled_1.SectionLabel, null, FieldLabels_enum_1.FieldLabels.signInOptions)), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.email,
        label: FieldLabels_enum_1.FieldLabels.email,
        isSecure: false,
        isDisabled: true,
        accessibilityLabel: "Enter your email"
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.phone,
        label: FieldLabels_enum_1.FieldLabels.phone,
        isSecure: false,
        isDisabled: true,
        accessibilityLabel: "Enter your phone number"
      }, props)))), react_1.default.createElement(styled_1.FormSection, null, react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(styled_1.SectionLabel, null, FieldLabels_enum_1.FieldLabels.personalInformation)), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.firstName,
        label: FieldLabels_enum_1.FieldLabels.firstName,
        isSecure: false,
        isDisabled: isSubmitting,
        accessibilityLabel: "Enter your first name"
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.lastName,
        label: FieldLabels_enum_1.FieldLabels.lastName,
        isSecure: false,
        isDisabled: isSubmitting,
        accessibilityLabel: "Enter your last name"
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.nickName,
        label: FieldLabels_enum_1.FieldLabels.nickName,
        isSecure: false,
        isDisabled: isSubmitting,
        accessibilityLabel: "Enter your nickname"
      }, props))), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: FieldNames_enum_1.FieldNames.country
      }), react_1.default.createElement(formik_1.Field, {
        component: components_lib_1.FormPicker,
        name: FieldNames_enum_1.FieldNames.country,
        label: FieldLabels_enum_1.FieldLabels.country,
        type: components_lib_1.FormPickerComponent.type.singleSelect,
        options: core_1.countryValues,
        disabled: isSubmitting,
        accessibilityLabel: "Country"
      })), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.zipCode,
        label: FieldLabels_enum_1.FieldLabels.zipCode,
        isSecure: false,
        isDisabled: isSubmitting,
        accessibilityLabel: "Enter your zip code"
      }, props))), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: FieldNames_enum_1.FieldNames.gender
      }), react_1.default.createElement(formik_1.Field, {
        component: components_lib_1.FormPicker,
        name: FieldNames_enum_1.FieldNames.gender,
        label: FieldLabels_enum_1.FieldLabels.gender,
        type: components_lib_1.FormPickerComponent.type.singleSelect,
        options: core_1.genderValues,
        disabled: isSubmitting,
        accessibilityLabel: "Gender"
      })), react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: FieldNames_enum_1.FieldNames.ethnicity
      }), react_1.default.createElement(formik_1.Field, {
        component: components_lib_1.FormPicker,
        name: FieldNames_enum_1.FieldNames.ethnicity,
        label: FieldLabels_enum_1.FieldLabels.ethnicity,
        type: components_lib_1.FormPickerComponent.type.singleSelect,
        options: core_1.ethnicityValues,
        disabled: isSubmitting,
        accessibilityLabel: "Ethnicity"
      })), react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: FieldNames_enum_1.FieldNames.specialNeeds
      }), react_1.default.createElement(formik_1.Field, {
        component: components_lib_1.FormPicker,
        name: FieldNames_enum_1.FieldNames.specialNeeds,
        label: FieldLabels_enum_1.FieldLabels.specialNeeds,
        type: components_lib_1.FormPickerComponent.type.multiSelect,
        options: core_1.specialNeedsValues,
        disabled: isSubmitting,
        accessibilityLabel: "Special Needs"
      }))), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: FieldNames_enum_1.FieldNames.educationalGoal
      }), react_1.default.createElement(formik_1.Field, {
        component: components_lib_1.FormPicker,
        name: FieldNames_enum_1.FieldNames.educationalGoal,
        label: FieldLabels_enum_1.FieldLabels.educationalGoal,
        type: components_lib_1.FormPickerComponent.type.singleSelect,
        options: core_1.educationalGoalValues,
        disabled: isSubmitting,
        accessibilityLabel: "Educational Goal"
      })))), react_1.default.createElement(styled_1.FormSection, null, react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(styled_1.SectionLabel, null, FieldLabels_enum_1.FieldLabels.changePassword)), react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(styled_2.ButtonLinkFixer, null, react_1.default.createElement(components_lib_1.Button, {
        onPress: _this.togglePasswordVisibility,
        type: components_lib_1.ButtonTypeEnum.link,
        text: "Click to Change",
        accessibilityLabel: "Click to Change Password",
        uppercase: false
      }))), renderPassword && react_1.default.createElement(Password_1.Password, __assign({}, props))), react_1.default.createElement(styled_2.FormSectionButtonsFixer, null, react_1.default.createElement(styled_2.ButtonsRow, null, react_1.default.createElement(styled_2.ButtonContainer, null, react_1.default.createElement(components_lib_1.Button, {
        type: components_lib_1.ButtonTypeEnum.primary,
        text: FieldLabels_enum_1.FieldLabels.updateChanges,
        onPress: _this.submitForm(props),
        disabled: _this.isSubmitButtonDisabled(props),
        uppercase: true,
        accessibilityLabel: "Update Changes",
        loading: isSubmitting || updating
      })), react_1.default.createElement(components_lib_1.AlignSelf, {
        alignSelf: "center"
      }, react_1.default.createElement(components_lib_1.Button, {
        text: "Back",
        uppercase: true,
        type: components_lib_1.ButtonTypeEnum.link,
        onPress: _this.navigate,
        accessibilityLabel: "Go Back"
      })))));
    };

    return _this;
  }

  UserProfileEditForm.prototype.submitForm = function (formProps) {
    return function () {
      formProps.submitForm();
    };
  };

  UserProfileEditForm.prototype.isSubmitButtonDisabled = function (formProps) {
    var updating = this.props.updating;
    var isValid = formProps.isValid,
        isSubmitting = formProps.isSubmitting,
        touched = formProps.touched;
    return touched && !isValid || isSubmitting || updating;
  };

  UserProfileEditForm.prototype.render = function () {
    var _a = this.props,
        onSubmit = _a.onSubmit,
        initialValues = _a.initialValues;
    var renderPassword = this.state.renderPassword;
    var validationSchema = userProfileEditFormValidationSchema_1.userProfileEditFormValidationSchema(renderPassword);
    return react_1.default.createElement(formik_1.Formik, {
      initialValues: initialValues,
      onSubmit: onSubmit(renderPassword),
      validationSchema: validationSchema,
      enableReinitialize: true,
      render: this.renderForm
    });
  };

  return UserProfileEditForm;
}(react_1.Component);

exports.default = core_1.withNavigateTo(UserProfileEditForm);